import Translator from 'tools/trans';
export default [
    {
        name: Translator.trans('NAVIGATION_AMO'),
        shortName: 'amo',
        id: '0',
        text: Translator.trans('OUTLOOK_OVERVIEW_AMO_DESCRIPTION'),
        teaser: Translator.trans('AMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/emarkets/amo-methodology-',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_AMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_CMO'),
        shortName: 'cmo',
        id: '1',
        text: Translator.trans('OUTLOOK_OVERVIEW_CMO_DESCRIPTION'),
        teaser: Translator.trans('CMO_LANDINGPAGE_SUBTITLE'),
        pdfUrl: 'img/outlook/CMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_CMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_CO'),
        shortName: 'co',
        id: '2',
        text: Translator.trans('OUTLOOK_OVERVIEW_CO_DESCRIPTION'),
        teaser: Translator.trans('CO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/co-methodology-',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_CO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_DMO'),
        shortName: 'dmo',
        id: '3',
        text: Translator.trans('OUTLOOK_OVERVIEW_DMO_DESCRIPTION'),
        teaser: Translator.trans('DMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/emarkets/dmo-methodology-',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_DMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_FMO'),
        shortName: 'fmo',
        id: '4',
        text: Translator.trans('OUTLOOK_OVERVIEW_FMO_DESCRIPTION'),
        teaser: Translator.trans('FMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/FMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_FMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_HMO'),
        shortName: 'hmo',
        id: '5',
        text: Translator.trans('OUTLOOK_OVERVIEW_HMO_DESCRIPTION'),
        teaser: Translator.trans('HMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/HMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_HMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_IO'),
        shortName: 'io',
        id: '6',
        text: Translator.trans('OUTLOOK_OVERVIEW_IO_DESCRIPTION'),
        teaser: Translator.trans('IO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/IO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_IO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_MMO'),
        shortName: 'mmo',
        id: '7',
        text: Translator.trans('OUTLOOK_OVERVIEW_MMO_DESCRIPTION'),
        teaser: Translator.trans('MMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/MMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_MMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_TMO'),
        shortName: 'tmo',
        id: '8',
        text: Translator.trans('OUTLOOK_OVERVIEW_TMO_DESCRIPTION'),
        teaser: Translator.trans('TMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/TMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_TMO_HIGHLIGHTS'),
    },
    {
        name: Translator.trans('NAVIGATION_EMO'),
        shortName: 'emo',
        id: '9',
        text: Translator.trans('OUTLOOK_OVERVIEW_EMO_DESCRIPTION'),
        teaser: Translator.trans('EMO_SHORT_DESCRIPTION'),
        pdfUrl: 'img/outlook/EMO-Methodik_',
        highlights: Translator.trans('OUTLOOK_OVERVIEW_EMO_HIGHLIGHTS'),
    },
];
